import React, { FC, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TeamProps } from '../../EventTypes'
import { TeamInfoDisplay } from './TeamInfoDisplay'
import CaptionTextDisplay from './CaptionTextDisplay'

type OptionalFieldProps = {
    caption?: string
    teamProps?: TeamProps
}

const PostEventRowOptionalField: FC<OptionalFieldProps> = ({ caption, teamProps }) => {
    if (!caption && !teamProps) {
        return null
    }
    return (
        <Grid marginLeft={64} height={18} centerVertical>
            {teamProps ? (
                <TeamInfoDisplay teamProps={teamProps} />
            ) : (
                <CaptionTextDisplay caption={caption} />
            )}
        </Grid>
    )
}

export default memo(PostEventRowOptionalField)
